import { AlgoliaArticle, AlmanacFile } from 'types'
import { ResultItem } from './ResultItem'
import { FileIcon } from 'screens/Finder/components/FileIcon/FileIcon'
import Styles from './ResultItem.module.scss'
import { Fragment } from 'react'
import { EmptyFile } from './EmptyFile/EmptyFile'

interface Props {
  item: AlgoliaArticle
}

export const ResultItemProject = ({ item }: Props) => {
  const file = {
    database_mode: item.database_mode,
    default_view: item.default_view,
    header_emoji: item.header_emoji,
    type: 'folder',
    isExpanded: false,
  } as any as AlmanacFile

  const previews = item.children_preview_urls
  const hasSomePreview = previews?.some((p) => p !== '')

  return (
    <ResultItem
      item={item}
      type="Project"
      preview={
        previews?.length > 0 && hasSomePreview ? (
          <div className={Styles.folderPreview}>
            {previews?.map((filePreview, index) => (
              <Fragment key={`file-preview-${index}-${filePreview}`}>
                {filePreview && (
                  <div className={Styles.previewContainer}>
                    <img src={filePreview} alt="preview" />
                  </div>
                )}
              </Fragment>
            ))}
            {Array.from(Array(4 - previews?.length)).map((x, i) => (
              <div key={i}></div>
            ))}
          </div>
        ) : (
          <div className={Styles.emptyFileContainer}>
            <EmptyFile type={previews?.length === 0 ? 'project' : 'preview'} />
          </div>
        )
      }
      icon={<FileIcon file={file} size="md" color="var(--dark-80)" />}
    />
  )
}
